import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

export const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-pill px-3 py-1 font-sans text-[length:var(--t-xs)] font-semibold',
  {
    variants: {
      variant: {
        neutral: 'bg-surface-3 text-ink-2',
        gold: 'bg-gold/[0.12] text-gold-text',
        ok: 'bg-[color:var(--ok-bg)] text-ok',
        warn: 'bg-[color:var(--warn-bg)] text-warn',
        danger: 'bg-[color:var(--danger-bg)] text-danger',
        info: 'bg-[color:var(--info-bg)] text-info',
        /** Selo Powerful — um dos poucos lugares onde o ouro metálico é permitido. */
        metal: 'bg-metal text-[color:var(--on-metal)]',
      },
    },
    defaultVariants: { variant: 'neutral' },
  },
);

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  ),
);

Badge.displayName = 'Badge';
